import React from "react";
import CategoryPage from "./CategoryPage";

export default function TorchlightPage() {
  return (
    <CategoryPage
      categoryMatch="torchlight"
      title="Torchlight"
      subtitle="Durable, high-output flashlights and torchlights for field, industrial, and security use."
      searchPlaceholder="Search torchlights..."
    />
  );
}